import { fromJS } from 'immutable';

// This is duplicated in CourseController.RESERVED_COURSE_PATHS
export const RESERVED_COURSE_PATHS = fromJS([
  'admin',
  'my',
  'go',
  'enrol',
  'create',
]);

export const DEFAULT_PAGE_TITLE = 'OpenLearning';
